import { Box, Stack, Typography } from '@mui/material'
import { GRAY_700, GRAY_900 } from 'constants/styling/theme'
import { UploadVisualsTypes, useClientPropertySelfUploadPopup } from './ClientPropertySelfUploadPopup.context'

import { AIEditingProductSettings } from 'components/pages/PurchaseFlow/common/EditingProductListing/AIEditingPhotoSettings'
import AllInclusiveIcon from '@mui/icons-material/AllInclusive'
import { DynamicFlowStep } from 'components/common/DynamicFlow'
import { FC } from 'react'
import { FeatureFlag } from 'utils/featureFlags'
import { MUIBadge } from 'components/common/MUIBadge'
import { MUICheckCard } from 'components/common/MUICards'
import ScienceOutlinedIcon from '@mui/icons-material/ScienceOutlined'
import { UploadVisualsStepKey } from './ClientPropertySelfUploadPopup.controller'
import { useFlag } from '@unleash/proxy-client-react'
import { useTranslation } from 'react-i18next'

export const UploadOptionsStep: FC = () => {
  const { t } = useTranslation(['self_upload_popup', 'common'])
  const isAIEditingUploadBeta = useFlag(FeatureFlag.IS_AI_EDITING_UPLOAD_BETA)
  const isAIEditingUploadUnlimited = useFlag(FeatureFlag.IS_AI_EDITING_UPLOAD_UNLIMITED)

  const {
    uploadVisualsType,
    setUploadVisualsType,
    isSkyReplacementEnabled,
    selectedSkyReplacement,
    setSelectedSkyReplacement,
    setIsSkyReplacementEnabled
  } = useClientPropertySelfUploadPopup()

  return (
    <DynamicFlowStep
      stepKey={UploadVisualsStepKey.OPTIONS}
      isValid={true}
    >
      <Stack alignItems="center" gap={3} padding="3.2rem 0">

        {Object.values(UploadVisualsTypes).map((key) => (
          <Box width="100%" key={key}>
            <MUICheckCard
              key={key}
              isRadio
              isHeaderClickable
              checked={uploadVisualsType === key}
              onCheck={() => setUploadVisualsType(key)}
              expandableContent={key === UploadVisualsTypes.AI_EDITING &&
                <AIEditingProductSettings
                  isSkyReplacementEnabled={isSkyReplacementEnabled}
                  selectedSkyReplacement={selectedSkyReplacement}
                  setSelectedSkyReplacement={setSelectedSkyReplacement}
                  setIsSkyReplacementEnabled={setIsSkyReplacementEnabled}
                />
              }
            >

              <Stack direction="row" gap={1} alignItems="center">

                <Typography variant="text-md" fontWeight={600} color={GRAY_900}>
                  {t(`upload_visuals_type.${key}.title`)}
                </Typography>

                {key === UploadVisualsTypes.AI_EDITING &&
                  <Stack direction="row" gap={1} alignItems="center">

                    {isAIEditingUploadBeta && <MUIBadge label={t('common:beta')} size="xs" color="blue" icon={<ScienceOutlinedIcon />} />}

                    {isAIEditingUploadUnlimited && <MUIBadge label={t('unlimited_for_now')} size="xs" color="green" icon={<AllInclusiveIcon />} />}

                  </Stack>
                }

              </Stack>

              <Typography variant="text-md" fontWeight={400} color={GRAY_700}>
                {t(`upload_visuals_type.${key}.description`)}
              </Typography>

            </MUICheckCard>
          </Box>
        ))}

      </Stack>
    </DynamicFlowStep>
  )
}
